import styled from "styled-components";
import Tabela2 from "../../../Componentes/Utils/Tabela2";
import { useEffect, useState } from "react";
import useApi from "../../../hooks/useApi";

const Container = styled.div`
    width: 100%;
    height: 100%;
`
const CelulaProgress = styled.td`
    width: 170px;
`
const ContainerProgress = styled.div`
    width: 100%;
    height: 30px;
    display: flex;
    align-items: center; 
    padding-left: 5px;
`
const ProgressContainer = styled.div`
    width: 80px;
    height: 5px;
    background-color: #ddd;
    border-radius: 5px;
    overflow: hidden;
`
const ProgressBar = styled.div`
    height: 100%;
    width: ${props => props.percent ? props.percent + '%' : '0%'};
    background-color: ${props => props.percent <= 50 ? '#f44336' : props.percent <= 75 ? '#ff9800' : '#4caf50'};
`
const PercentText = styled.span`
    margin-left: 10px;
    font-size: 12px;
    color: #333;
`

const Content = () => {

    const api = useApi();

    const [metas, setMetas] = useState([]);

    const getMetas = async () => {

        const { data } = await api.get('Painel/API/Checklist/MinhasMetas/');

        setMetas(data);
        console.log(data);

    }

    useEffect(() => {

        getMetas();

    }, [])

    return (
        <>
            <Container>
                <Tabela2>
                    <thead>
                        <tr>
                            <th>CHECKLIST</th>
                            <th>PROGRESSO</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            metas.map((meta, index) => {

                                const percent = ((meta.realizados / meta.meta_semanal) * 100).toFixed(2);

                                return (
                                    <tr key={index}>
                                        <td>{meta.nome}</td>
                                        <td>{meta.realizados}/{meta.meta_semanal}</td>
                                        <CelulaProgress>
                                            <ContainerProgress>
                                                <ProgressContainer>
                                                    <ProgressBar percent={percent} />
                                                </ProgressContainer>
                                                <PercentText>{percent}%</PercentText>
                                            </ContainerProgress>
                                        </CelulaProgress>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </Tabela2>
            </Container >
        </>
    )
}

export default Content;